module.exports = __webpack_public_path__ + "img/04.af35d8f2.png";